import React, { useRef, useState } from 'react';
import MainIntroduction from 'components/programAbout/parts/MainIntroduction';
import ResponsiveSubNavBar from 'components/programAbout/parts/ResponsiveSubNavBar';
import SubNavBar from 'components/programAbout/parts/SubNavBar';
import { EMentoringPurchaseURLQuery } from 'modules/mentoring';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, device } from 'GlobalStyles';
import Arrow from 'assets/Arrow.webp';
import titleImage from 'assets/images/banners/2.webp';
import applyImage from 'assets/images/banners/6.webp';
import thumbnail1 from 'assets/images/pages/programAbout/consulting_about_1.webp';
import thumbnail13 from 'assets/images/pages/programAbout/consulting_about_13.webp';
import thumbnail14 from 'assets/images/pages/programAbout/consulting_about_14.webp';
import thumbnail15 from 'assets/images/pages/programAbout/consulting_about_15.webp';
import thumbnail2 from 'assets/images/pages/programAbout/consulting_about_2.webp';
import thumbnail3 from 'assets/images/pages/programAbout/consulting_about_3.webp';
import thumbnail4 from 'assets/images/pages/programAbout/consulting_about_4.webp';
import thumbnail5 from 'assets/images/pages/programAbout/consulting_about_5.webp';
import thumbnail7 from 'assets/images/pages/programAbout/consulting_about_7.webp';
import thumbnail8 from 'assets/images/pages/programAbout/consulting_about_8.webp';
import thumbnail9 from 'assets/images/pages/programAbout/consulting_about_9.webp';
import pyramidImage from 'assets/images/pages/programIntroduce/pyramidImg.webp';
import pyramidImage2 from 'assets/images/pages/programIntroduce/pyramidImg2.webp';
import MainIntroduction2 from './parts/MainIntroduction2';
import MainIntroduction4 from './parts/MainIntroduction4';

const { Text, Title } = Typography;
const maxWidth = CWindowWidth - 200;

interface IMainIntroduction {
  firstArticle?: boolean;
  bg?: boolean;
  responsiveBg?: boolean;
}

const ConsultingProgramAbout = () => {
  const contentsDom = useRef<any>({
    content1: '',
    content2: '',
    content3: '',
    content4: '',
    content5: '',
    content6: '',
  });
  const [noticeLoadImg, setNoticeLoadImg] = useState(false);

  // function handleClickInquiry() {
  //   message.info('오른쪽 아래 말풍선을 클릭하면 실시간 상담이 가능합니다.');
  // }

  let contents = {
    title: 'Frameworks 듣고 보기',
    subTitle: '컨설팅 인터뷰 준비 방법에 대한 핵심 Guide',
    description: [
      {
        title: '커리어스텝 "노하우의 핵심을 담은 설명"',
        explanation: ['Fit부터 Case까지 기본 개념 상세 설명', '질문 유형별 답변원칙 및 연습방법 제안'],
        thumbnail: thumbnail1,
      },
      {
        title: '커리어스텝 멘토진의 "생생한 설명 영상"',
        explanation: [
          '질문별 중요도와 핵심 원리에 대한 멘토진의 팁',
          '인터뷰 현장을 체험할 수 있는 Mock 인터뷰 예시',
        ],
        thumbnail: thumbnail2,
      },
      {
        title: '실제 인터뷰 형식의 "케이스 예제"',
        explanation: ['MBB 멘토가 풀이한 Frameworks', '실제와 동일한 Delivery 예시'],
        thumbnail: thumbnail3,
      },
    ],
    btnTitle: { title: 'Frameworks 시작하기', guideLink: `${ERoute.CSLearningBoard}` },
  };

  let contents2 = {
    title: '전략컨설팅 인터뷰 MasterClass (기초반)',
    subTitle: 'MBB 출신 멘토들과 하루안에 인터뷰에 필요한 모든 것을 학습해 보세요',
    description: [
      {
        title: '컨설팅 인터뷰 101',
        explanation: 'MBB 인터뷰어가 면접에서 검증하고 싶은 핵심 요소가 무엇인지 설명드립니다.',
      },
      {
        title: '전략적 사고 Self 학습법',
        explanation: '수많은 MBB 합격자를 탄생 시킨 커리어스텝만의 효과적인 전략적 사고 학습법을 소개합니다.',
      },
      {
        title: 'Fit 인터뷰',
        explanation: 'MBB에서 찾는 인재처럼 내 스토리를 전달할 수 있도록 도와드립니다.',
      },
      {
        title: 'Case 유형별 접근법',
        explanation:
          '케이스 플이의 기본 개념부터 Turnaround, Growth 등 케이스 유형별 접근법까지 설명드립니다.',
      },
    ],
    btnTitle: {
      title: '케이스 문제 시작하기',
      guideLink: `https://forms.gle/GARMEpPGxbEQVJdCA`,
    },
    guidePrice: {
      title: '강의 신청하러 가기',
      subTitle:
        '기초반 강의는 격달(2월, 4월, 6월, 8월, 10월)로 진행되며 강의가 있는 월 1일에 신청 링크가 오픈됩니다.',
      subTitle2: '오프라인 강의 참여가 어려운 분들을 위해 온라인 라이브와 오프라인 강의가 동시에 제공돼요',
      ticket: [
        {
          title: [
            'MBB 출신 시니어 + 주니어 멘토의 강의',
            '케이스 문제 (3개월 이용 가능)',
            'Career Step 시니어 Mock 수강권 1회 (추첨)',
          ],
          discount: '120',
          price: '55',
          period: '',
          purchaseLink: `https://forms.gle/GARMEpPGxbEQVJdCA`,
        },
      ],
    },
  };

  let contents3 = {
    title: '케이스 문제 풀어보기',
    subTitle: '커리어스텝이 제안하는 가장 효과적인 케이스 연습방법',
    description: [
      {
        title: '“240개 이상의 유형별 문제" 제공',
        explanation: ['케이스 풀이 단계별로 취약 부분 집중 연습', '케이스 유형 별로 전체 인터뷰 흐름 체험'],
        thumbnail: thumbnail4,
      },
      {
        title: '"즉시 채점"과 상세한 해설 제공',
        explanation: [
          '답안 제출시 바로 정오답 판별과 전체 정답률 제공',
          '문제에 대한 커리어스텝 멘토의 상세한 해설 제공',
        ],
        thumbnail: thumbnail5,
      },
    ],
    btnTitle: { title: '케이스 문제 시작하기', guideLink: `${ERoute.CSLearningQuizList}` },
    guidePrice: {
      title: '케이스 문제 구매하기',
      ticket: [
        {
          title: '케이스 문제 1개월 이용권',
          discount: '15',
          price: '10',
          period: '3개월',
          purchaseLink: `${ERoute.CSLearningPurchasePage}`,
        },
      ],
    },
  };

  let contents4 = {
    title: '전략컨설팅 인터뷰 MasterClass [실습편]',
    subTitle: '산업 분석과 마켓사이징 강의부터 1:1 Mock 인터뷰까지 하루안에 학습해 보세요',
    description: [
      {
        title: '구조적 사고 및 인터뷰 접근법 강의',
        explanation:
          '인터뷰 모든 순간에 필요한 구조화와 우선순위화 연습법을 전달드리고 Self 학습 방법에 대해서도 알려드립니다.',
      },
      {
        title: '산업 분석 강의 및 실습',
        explanation:
          '산업의 영역 정의부터 사업, 매출, 비용의 구조를 파악하는 법을 배우고 실습을 통해 Self 학습방법까지 전달합니다.',
      },
      {
        title: '마켓사이징 강의 및 실습',
        explanation: '시장의 범위를 정하는 연습 부터 Driver 쪼개기 및 핵심 Driver를 찾는법까지 알려드립니다.',
      },
      {
        title: '1:1 Mock 인터뷰',
        explanation:
          'MBB 출신 멘토와 1:1로 30분간 Mock 인터뷰가 진행됩니다. 강의 정원이 정해진 만큼 선착순으로 희망 멘토 선택이 가능함으로 빠른 신청 부탁드려요!',
      },
    ],
    btnTitle: { title: '케이스 문제 시작하기', guideLink: `${ERoute.CSLearningQuizList}` },
    guidePrice: {
      title: '강의 신청하러 가기',
      subTitle:
        '실습반 강의는 격달(3월, 5월, 7월, 9월, 11월)로 진행되며 강의가 있는 월 1일에 신청 링크가 오픈됩니다.',
      ticket: [
        {
          title: [
            'MBB 출신 시니어 + 주니어 멘토의 강의',
            '케이스 문제 (3개월 이용 가능)',
            'Career Step 시니어 Mock 수강권 1회 (추첨)',
          ],
          discount: '120',
          price: '55',
          period: '',
          purchaseLink: `https://forms.gle/VKT5rnt5rNHL9uSP9`,
        },
      ],
    },
  };

  let contents5 = {
    title: '케이스 노트 연습하기',
    subTitle: '커리어스텝 오리지널 케이스와 합격자의 다양한 해답을 지금 바로 확인해보세요',
    description: [
      {
        title: 'MBB 최신 기출 기반 "트렌디한 Cases"',
        explanation: [
          '자율주행차, 디지털 금융 등 최근 업계에서 가장 핫한 토픽과 산업 반영',
          '실제 MBB Case 인터뷰와 매우 흡사한 문제 구성 및 진행 방식',
        ],
        thumbnail: thumbnail7,
      },
      {
        title: '"10명 이상의 멘토"가 직접 풀이한 해설',
        explanation: [
          'MBB 전/현직 컨설턴트들의 개성있는 Case 접근법과 Frameworks 수록',
          '실제 면접상황에서의 다양한 Delivery 방식과 Communication 노하우까지',
        ],
        thumbnail: thumbnail8,
      },
      {
        title: '자유롭게 토론하는 "Discussion room"',
        explanation: [
          'Case 문제와 다양한 해설에 대해 멘토, 멘티 모두 자유로운 의견 공유',
          '나만의 해설을 올리고 멘토 피드백을 받는 공간',
        ],
        thumbnail: thumbnail9,
      },
    ],
    btnTitle: { title: '케이스 노트 시작하기', guideLink: `${ERoute.CaseIntroduction}` },
    guidePrice: {
      title: '케이스 노트 구매하기',
      ticket: [
        {
          title: '케이스 노트',
          price: '5',
          period: '1개',
          purchaseLink: `${ERoute.CaseBoard}`,
        },
        {
          title: '케이스 노트 패키지 이용권',
          price: '45',
          period: '10개',
          purchaseLink: `${ERoute.CaseBoard}`,
        },
      ],
    },
  };

  let contents6 = {
    title: '실전 Mock 인터뷰',
    subTitle: '1회 혹은 5회 구성으로 컨설팅 지원을 위한 실전 연습을 제공합니다',
    description: [
      {
        title: '맞춤형으로 선택하는 "90명 이상의 멘토진"',
        explanation: [
          '컨설팅 펌별, 직급별 멘토진 선택 가능',
          '원하시는 분들에게는 나에게 맞는 멘토 선택 및 멘토링 주제 구성에 대한 설계 지원',
        ],
        thumbnail: thumbnail13,
      },
      {
        title: '일정을 직접 선택하는 "멘토링 시간 자유도"',
        explanation: ['멘토가 오픈한 시간 slot 중에서 신청해 진행', '일정 변경 및 시간 추가 오픈 요청 가능'],
        thumbnail: thumbnail14,
      },
      {
        title: '상세한 서면 "피드백과 통계 분석"',
        explanation: ['멘토링 종료시 상세한 서면 피드백 제공', '합격자와 비교가능한 다각도의 분석 대시보드'],
        thumbnail: thumbnail15,
      },
    ],
    btnTitle: {
      title: '실전 Mock 인터뷰 시작하기',
      guideLink: `${ERoute.MentoringMentorList}`,
      subTitle: true,
    },
    guidePrice: {
      title: '실전 Mock interview 구매하기',
      subTitle: '패키지는 시니어 멘토 3회, 주니어 멘토 2회로 구성되어있습니다',
      subTitle2: '시니어는 실제 면접에 인터뷰어로 참여한 이사/EM 이상급, 주니어는 1~6년차 컨설턴트 출신',
      ticket: [
        {
          title: '주니어 멘토 Mock 인터뷰 이용권',
          price: '25',
          period: '1회',
          purchaseLink: `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewJunior}`,
        },
        {
          title: '시니어 멘토 Mock 인터뷰 이용권',
          price: '40',
          period: '1회',
          purchaseLink: `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewSenior}`,
        },
        {
          title: 'Mock 인터뷰 패키지 이용권',
          price: '150',
          period: '5회',
          purchaseLink: `/purchase/mentoring_ticket?mentoring_type=${EMentoringPurchaseURLQuery.MockInterviewPackage}`,
        },
      ],
    },
  };

  return (
    <StyledContainer>
      <PrevIntroduction>
        <div className='container'>
          <Title>프로그램 소개</Title>
          <Text>Career Step 의 프로그램 구성 방향성</Text>

          <IntroduceVideo>
            <PyramidImg src={pyramidImage} onLoad={() => setNoticeLoadImg(true)} />
            <div className='videoBox'>
              <iframe
                src='https://www.youtube.com/embed/DvIYQbWrPA0'
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              ></iframe>
              <h3 className='descriptionLine'>"암기가 아니라 사고력을 키울 수 있는 연습이 필요합니다."</h3>
            </div>
          </IntroduceVideo>

          <ResponsiveIntroduceVideo>
            <PyramidImg src={pyramidImage2} />
            <h3 className='descriptionLine'>"암기가 아니라 사고력을 키울 수 있는 연습이 필요합니다."</h3>
            <div className='videoBox'>
              <iframe
                src='https://www.youtube.com/embed/DvIYQbWrPA0'
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              ></iframe>
            </div>
          </ResponsiveIntroduceVideo>

          <SubIntroduction>
            <Title>나에게 맞는 프로그램 찾기</Title>
            <Text>
              Career Step은 멘토링 서비스뿐만 아니라 개인의 필요에 맞는 다양한 레벨의 프로그램을 제공하고
              있습니다.
            </Text>
          </SubIntroduction>

          <QuestionBoxes>
            <QuestionBox>
              <QuestionBoxContent>
                컨설팅 준비
                <br />
                1일차라면?
              </QuestionBoxContent>
              <ArrowImg src={Arrow} />
            </QuestionBox>

            <QuestionBox>
              <QuestionBoxContent>
                인터뷰에 필요한 모든
                <br />
                기초 준비를 한번에 끝내고 싶다면?
              </QuestionBoxContent>
              <ArrowImg src={Arrow} />
            </QuestionBox>

            <QuestionBox>
              <QuestionBoxContent>
                본격적으로 케이스
                <br />
                풀기를 시작했다면?
              </QuestionBoxContent>
              <ArrowImg src={Arrow} />
            </QuestionBox>

            {
              <QuestionBox>
                <QuestionBoxContent>
                  컨설턴트의 사고법을
                  <br />
                  완벽하게 내 것으로
                  <br />
                  만들고 싶다면?
                </QuestionBoxContent>
                <ArrowImg src={Arrow} />
              </QuestionBox>
            }

            <QuestionBox>
              <QuestionBoxContent>
                합격자의 케이스
                <br />
                해답이 궁금하다면?
              </QuestionBoxContent>
              <ArrowImg src={Arrow} />
            </QuestionBox>

            <QuestionBox>
              <QuestionBoxContent>
                곧 면접을 앞두고
                <br />
                있다면?
              </QuestionBoxContent>
              <ArrowImg src={Arrow} />
            </QuestionBox>
          </QuestionBoxes>
        </div>
      </PrevIntroduction>

      <SubNavBar contentsDom={contentsDom} notice={noticeLoadImg} />
      <ResponsiveSubNavBar />

      <MainIntroductions bg ref={(el) => (contentsDom.current.content1 = el)}>
        <MainIntroduction contents={contents} />
      </MainIntroductions>

      <MainIntroductions responsiveBg ref={(el) => (contentsDom.current.content2 = el)}>
        <MainIntroduction4 />
      </MainIntroductions>

      <MainIntroductions bg ref={(el) => (contentsDom.current.content3 = el)}>
        <MainIntroduction contents={contents3} caseQuiz />
      </MainIntroductions>

      <MainIntroductions ref={(el) => (contentsDom.current.content4 = el)}>
        <MainIntroduction2 contents={contents4} linkRequired={false} />
      </MainIntroductions>

      <MainIntroductions bg ref={(el) => (contentsDom.current.content5 = el)}>
        <MainIntroduction contents={contents5} />
      </MainIntroductions>

      <MainIntroductions responsiveBg ref={(el) => (contentsDom.current.content6 = el)}>
        <MainIntroduction contents={contents6} />
      </MainIntroductions>
    </StyledContainer>
  );
};

export default React.memo(ConsultingProgramAbout);

const IntroduceVideo = styled.div`
  position: relative;
  width: 1140px;
  margin: 0 auto;

  @media screen and ${device.xl} {
    width: 900px;
  }

  @media screen and ${device.lg} {
    width: 700px;
  }

  @media screen and ${device.lg} {
    display: none;
  }

  .videoBox {
    position: absolute;
    top: 55px;
    right: 30px;

    @media screen and ${device.xl} {
      top: 55px;
      right: 25px;
    }

    @media screen and ${device.lg} {
      top: 45px;
      right: 20px;
    }

    iframe {
      width: 422px;
      height: 239px;

      @media screen and ${device.xl} {
        width: 330px;
        height: 187px;
      }

      @media screen and ${device.lg} {
        width: 250px;
        height: 142px;
      }
    }

    .descriptionLine {
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
      font-weight: 900;
      color: ${SecondaryColor};

      @media screen and ${device.xl} {
        margin-top: 3px;
        font-size: 10px;
      }
    }
  }
`;

const ResponsiveIntroduceVideo = styled.div`
  display: none;

  @media screen and ${device.lg} {
    display: block;
  }

  .descriptionLine {
    margin: 50px 0 10px 0;
    font-size: 20px;
    font-weight: 700;
    color: ${SecondaryColor};
    text-align: center;

    @media screen and ${device.md} {
      margin-top: 35px;
      font-size: 13px;
    }
  }

  .videoBox {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
  }

  .videoBox iframe,
  .videoBox object,
  .videoBox embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const StyledContainer = styled.section`
  margin-top: 140px;
  word-break: keep-all;

  @media screen and ${device.lg} {
    margin-top: 100px;
  }
`;

const PrevIntroduction = styled.article`
  .container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 50px;

    @media screen and ${device.lg} {
      padding: 20px;
    }
  }

  h1.ant-typography {
    margin-bottom: 3px;
    font-size: 32px;
    color: ${PrimaryColor};

    @media screen and ${device.lg} {
      margin-bottom: 0;
      font-size: 20px;
    }
  }

  span.ant-typography {
    font-size: 24px;
    color: ${PrimaryColor};

    @media screen and ${device.lg} {
      font-size: 14px;
    }
  }
`;

const SubIntroduction = styled.div`
  display: flex;
  align-items: center;
  margin: 50px 0 20px 0;

  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: flex-start;
  }

  h1.ant-typography {
    margin: 0 15px 0 0;
    font-size: 20px;
    color: ${SecondaryColor};

    @media screen and ${device.lg} {
      margin-bottom: 5px;
    }
  }

  span.ant-typography {
    font-size: 14px;
    color: #747474;
  }
`;

const PyramidImg = styled.img`
  width: 100%;
  margin-top: 30px;

  @media screen and ${device.lg} {
    display: block;
    width: 90%;
    margin: 25px auto 0 auto;
  }
`;

const QuestionBoxes = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: ${maxWidth}px;
  margin: 0 auto;

  @media screen and ${device.lg} {
    display: none;
  }
`;

const QuestionBox = styled.div`
  position: relative;
`;

const QuestionBoxContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 170px;
  padding: 20px 0;
  border-radius: 5px;
  color: #14112a;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  background-color: #f9f9f9;
  z-index: 2;

  @media screen and ${device.xl} {
    width: 130px;
    font-size: 13px;
  }
`;

const ArrowImg = styled.img`
  position: absolute;
  width: 20px;
  top: 70px;
  right: 75px;
  z-index: 1;

  @media screen and ${device.xl} {
    right: 55px;
  }
`;

const MainIntroductions = styled.section<IMainIntroduction>`
  background: ${({ bg }) => (bg ? '#f9f9f9' : '#ffffff')};

  @media screen and ${device.lg} {
    background: ${({ responsiveBg }) => (responsiveBg ? '#f9f9f9' : '#ffffff')};
  }
`;

export const ConsultingProgramAboutWrapper = styled.div`
  .apply-mentoring {
    height: 248px;
    border-radius: 8px;
    background-color: #2a4753;
    background-image: url(${applyImage});
    background-repeat: no-repeat;
    background-position-x: 100%;
    margin: 40px 50px 60px 50px;

    @media screen and ${device.md} {
      margin: 20px 0px;
    }

    .apply-mentoring-content {
      max-width: ${CWindowWidth - 300}px;
      margin: auto;
      padding: 50px 10px;
    }
  }

  .title_wrapper {
    width: 100%;
    height: 220px;

    background-size: cover;
    padding: 70px 10px;
    .ant-typography {
      width: 100%;
      max-width: ${CWindowWidth - 300}px;
      color: #fff;
      margin: auto;
      display: block;
    }
    span.ant-typography {
      font-size: 16px;
    }
  }

  .name-list {
    color: #000;

    img {
      margin-right: 10px;
    }
  }

  .ant-list-item-meta {
    margin: 10px 0px;
  }

  .ant-list-item-meta-description {
    color: #000;
  }

  .step {
    color: ${PrimaryColor};
    font-weight: bold;
  }

  .company-logo {
    height: 75px;
    width: auto;
  }

  .company-logo-wide {
    height: 50px;
    width: auto;
  }

  .title-mentoring {
    width: 100%;
    height: 300px;
    background: linear-gradient(0deg, rgba(42, 71, 83, 0.3), rgba(42, 71, 83, 0.3)), url(${titleImage});
    background-size: cover;
    padding: 50px 10px;

    .ant-typography {
      width: 100%;
      color: #ffffff;
      margin: auto;
      display: block;
    }

    span.ant-typography {
      font-size: 16px;
    }
  }

  .btn-responsive {
    padding: 0px !important;
    font-size: 1.2em;
    max-width: 100px;
    margin-bottom: 5px;
    background-color: ${SecondaryColor} !important;
    color: #fff !important;
  }

  .container {
    max-width: ${maxWidth}px;
    margin: auto;
    padding: 0px 3px;
  }

  .offering_header {
    font-size: 10px;
    border-bottom: 1px solid ${SecondaryColor};
    color: #000;
    padding: 0px;
  }

  .offering_header_list {
    font-size: 10px;
    max-width: 350px;
    margin: auto;
    text-align: center;

    @media ${device.md} {
      font-size: 5px;
    }

    .offering_title {
      font-weight: bold;
      margin: 5px 0px;
      font-size: 1.4em;
      white-space: pre;
    }
  }

  .price {
    color: ${SecondaryColor};
  }

  .offering_list {
    font-weight: bold;
    color: ${PrimaryColor};
    font-size: 16px;

    @media ${device.md} {
      font-size: 10px;
    }
  }

  .service {
    color: #000;
    margin-top: 40px;
    padding: 0px 8px;

    p {
      margin-bottom: 4px;
    }

    .green-title {
      margin-top: 7px;
      font-size: 16px;
      margin-bottom: 1px;
      color: ${SecondaryColor};
    }

    .detail {
      font-size: 14px;
      margin-top: 1px;
    }
  }
`;
